/**
* Created by Dixi Gu on 2021/5/17.
*/
<template>
  <div class="body-mobile">
    <index-header page="home"></index-header>

    <div class="content-box" v-if="currentEnroll && currentEnroll.publishStatus">
      <div class="title">
        {{currentEnroll && currentEnroll.title}}
      </div>
      <div class="divider">
        录取名单
      </div>
      <div class="searcher">
        <md-input-item
          v-model="searchVal"
          placeholder="学校名称/姓名/身份证号"
          :maxlength="30"
        >
          <div class="input-operator" slot="right" @click="onSearch">搜索</div>
        </md-input-item>
      </div>
      <div class="scroll-view">
        <md-scroll-view
          ref="scrollView"
          :scrolling-x="false"
          @end-reached="loadMore"
        >
          <div
            v-for="item in tableData"
            :key="item.id"
            class="student-item"
          >
            <div class="name">{{item.studentName}}</div>
            <div class="content"><span class="label">身份证号：</span>{{item.idCard}}</div>
            <div class="content"><span class="label">学校名称：</span>{{item.schoolName}}</div>
          </div>
          <md-scroll-view-more
            slot="more"
            :is-finished="isFinished"
          >
          </md-scroll-view-more>
        </md-scroll-view>
      </div>
    </div>

    <div class="content-box" v-else>
      <div class="flex-center" style="font-size: 0.3rem">
        暂未发布录取名单！
      </div>
    </div>
  </div>
</template>

<script>

  import IndexCommon from '../index/mixins/index_common';
  import MobileCommon from '../index/mixins/mobile_common';
  import PageIndex from '../index/mixins/page_index';
  import IndexHeader from './components/IndexHeader';
	export default {
		mixins: [IndexCommon,MobileCommon,PageIndex],
		props: [],
		components: {IndexHeader},
		data() {
			return {
        currentEnroll: null,
        searchVal:'',
        list:10,
        isFinished: false,
        pageableDto:{
          page:1,
          size:10,
          total:0,
        },
        tableData:[],
      };
		},
		created() {
		},
		async mounted() {
		  this.getEnroll()
      let data = await this.getEnrollList(this.pageableDto)
      this.tableData = data
		},
		watch: {},
		methods: {
      async onSearch(){
        this.pageableDto.page = 1
        let data = await this.getEnrollList(this.pageableDto)
        this.tableData = data
      },
      async loadMore(){
        let {page} = this.pageableDto
        if(!this.isFinished){
          let data = await this.getEnrollList({...this.pageableDto,page:page+1})
          this.tableData = this.tableData.concat(data)
        }
        this.$refs.scrollView.finishLoadMore()

      },
      async getEnroll(){
        // 查询录取通知信息 #敬瑞/2021-05-17#
        let {data} = await this.$ajax.gateway("/bm-kids/admission_getAdmissionOut", {
          "METHOD": "get"
        });
        this.currentEnroll = data.data
      },
      async getEnrollList(page){
        // 查询录取通知学生信息 #敬瑞/2021-05-14#
        let {data} = await this.$ajax.gateway("/bm-kids/admission_listAdmissionStudentOut", {
          "body": {
            "pageableDto": page,
            "search": this.searchVal
          }
        });
        this.pageableDto.page = data.data.currentPage
        this.pageableDto.total = data.data.totalCount
        this.isFinished = data.data.totalPage <= this.pageableDto.page
        return data.data.dataList
      }
    }
	};
</script>
<style lang="stylus" scoped>
  .body-mobile
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 100%;

  .content-box
    overflow auto
    flex 1
    display flex
    justify-content: center;
    flex-direction: column;
    background-color #ffffff
    border-radius 0.2rem
    margin 1rem 0.3rem
    padding 0.8rem 0.5rem
    box-shadow: 0px 0.02rem 0.4rem 0px rgba(25,151,138,0.39) inset, 0px 1px 0.3rem 0px rgba(60,205,179,0.51) inset;

  .title
    text-align center
    font-size 0.4rem
    font-weight bold
  .divider
    font-size 0.3rem
    padding 16px 0
    border-bottom 1px solid #CCCCCC
  .searcher
    margin-top 0.6rem
    >>>.md-field-item-content:before
      background-color unset!important
    >>>.md-field-item-control
      input
        height 0.8rem
        border-radius .5rem 0 0 .5rem
        border 2px solid #CCC
        border-right none
        padding 0 0.15rem
    >>>.md-field-item-right
      border-radius 0 .5rem .5rem 0
      border 2px solid #CCC
      border-left none
      margin-left 0
      padding 0 0.3rem 0 0.15rem
      height 0.8rem
      color #ffffff
      background-color rgb(97,213,173)

  .scroll-view
    flex 1
    overflow auto
  .student-item
    border-bottom 2px solid #CCC
    padding .2rem 0
    .name
      font-size 0.4rem
      font-weight bold
    .label
      color #CCC
    .content
      font-size .25rem

  .flex-center
    display flex
    justify-content center
    align-items center
</style>